import { render, staticRenderFns } from "./HighlightedAboutUs.vue?vue&type=template&id=2e206af4&scoped=true&"
import script from "./HighlightedAboutUs.vue?vue&type=script&lang=js&"
export * from "./HighlightedAboutUs.vue?vue&type=script&lang=js&"
import style0 from "./HighlightedAboutUs.vue?vue&type=style&index=0&id=2e206af4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e206af4",
  null
  
)

export default component.exports